import Grid from '@mui/material/Grid';
import { Fragment } from 'react';
import { useEffect } from 'react';

import CompleteYourReservation from 'reservations/availabilities/components/CompleteYourReservation';
import { useHasVisitId } from 'reservations/base/hooks/useQueryParams';
import { useBookingHasFee } from 'reservations/booking/providers/BookingProvider';
import { useBookingEmail } from 'reservations/booking/providers/BookingProvider';
import { DinerAuthenticationInput } from 'reservations/dinerAccount/components/DinerAuthenticationInput';
import { useDinerAccount } from 'reservations/dinerAccount/hooks/useDinerAccount';
import { useIsSubjectToCancellationFee } from 'reservations/feePolicy/hooks';
import { BookingFields } from 'reservations/form/components/BookingFields';
import DinerInformationReadOnlyModify from 'reservations/form/components/DinerInformationReadOnlyModify';
import UpdateReservationButton from 'reservations/form/components/UpdateReservationButton';
import { UpdateReservationButtonV2 } from 'reservations/form/components/UpdateReservationButtonV2';
import { RequiredPaymentModify } from 'reservations/payments/components/RequiredPayment';

export const ModifyFields = () => {
  const email = useBookingEmail();
  const {
    setBeginAuthParams,
    isDinerAccountAuthenticated,
    dinerAccountExists
  } = useDinerAccount();
  const bookingHasFee = useBookingHasFee();
  const hasVisitId = useHasVisitId();
  const isSubjectToCancellationFee = useIsSubjectToCancellationFee();
  const shouldAuthenticate =
    (bookingHasFee ||
      hasVisitId ||
      (dinerAccountExists && isSubjectToCancellationFee)) &&
    !isDinerAccountAuthenticated;

  useEffect(() => {
    if (shouldAuthenticate) {
      setBeginAuthParams(email);
    }
  }, [shouldAuthenticate]);

  const ButtonV2Wrapper = isSubjectToCancellationFee
    ? RequiredPaymentModify
    : Fragment;

  const ButtonV2 = () => (
    <ButtonV2Wrapper>
      <UpdateReservationButtonV2 />
    </ButtonV2Wrapper>
  );
  const Button = hasVisitId ? ButtonV2 : UpdateReservationButton;

  return (
    <>
      <Grid item>
        <CompleteYourReservation />
      </Grid>
      {shouldAuthenticate ? (
        <DinerAuthenticationInput />
      ) : (
        <>
          <Grid container item gap="16px" direction="column">
            <DinerInformationReadOnlyModify />
            <BookingFields />
          </Grid>
          <Grid item>
            <Button />
          </Grid>
        </>
      )}
    </>
  );
};
